module.exports = __webpack_public_path__ + "img/shopping-cart-1.ca180f91.svg";